
import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';
import Kontaktizleti  from './kontaktizleti.js';

import { useTranslation } from 'react-i18next';

const Klis = (props) => {

const { t } = useTranslation();

  return (
  	<div>
      
            <div className="container"> 
            <div>
              <img className="logo" src="slike/logo.png" alt="logo"/>
          </div>
              <div id="carouselExampleIndicators" className="carousel slide " data-ride="carousel">
                <ol className="carousel-indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img className="d-block w-100" src="slike/izleti/izleti/klis1.jpg" alt="First slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/zadar3.jpg" alt="Second slide"/>
                  </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="slike/izleti/izleti/klis3.jpg" alt="Third slide"/>
                  </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="sr-only"></span>
                </a>
              </div>
              <div className="text">
                <h2 className="h2izlet">{ t('klis.klis-title') }</h2>
                <div>
                  <Button id="opcenito" className="morebtn" >{ t('klis.klis-Overview-title') }</Button>
                    <UncontrolledCollapse toggler="#opcenito">
                      <Card>
                        <CardBody>
                          <p>{ t('klis.klis-Overview-text') }</p>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                  </div>
                <hr className="line"/>
                <div>
                  <Button id="ukljuceno" className="morebtn">{ t('klis.klis-title-2') }</Button>
                    <UncontrolledCollapse toggler="#ukljuceno">
                      <Card>
                        <CardBody>
                <ul>
                  <li>{ t('klis.klis-list-1') }</li>
                  <li>{ t('klis.klis-list-2') }</li>
                  <li>{ t('klis.klis-list-3') }</li>
                  <li>{ t('klis.klis-list-4') }</li>
                  <li>{ t('klis.klis-list-5') })</li>
                  <li>{ t('klis.klis-list-6') }</li>
                  <li>{ t('klis.klis-list-7') }</li>
                  <li>{ t('klis.klis-list-8') }</li>
                </ul>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>
                <div>
                  <Button id="odlazak" className="morebtn">{ t('klis.klis-title-3') }</Button>
                    <UncontrolledCollapse toggler="#odlazak">
                      <Card>
                        <CardBody>
                          <p>{ t('klis.klis-text-2') }
                          </p>
                          </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="ulaznica" className="morebtn">{ t('klis.klis-title-4') }</Button>
                    <UncontrolledCollapse toggler="#ulaznica">
                      <Card>
                        <CardBody>
                          <p>
                          { t('klis.klis-price-list-1') }
                          </p>
                          <ul>
                            <li>{ t('klis.klis-price-list-2') }</li>
                            <li>{ t('klis.klis-price-list-3') }</li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="itinerar" className="morebtn">{ t('klis.klis-title-5') }</Button>
                    <UncontrolledCollapse toggler="#itinerar">
                      <Card>
                        <CardBody>
                          <p>{ t('klis.klis-itinerar-txt-1') }</p>
                          <p>{ t('klis.klis-itinerar-txt-2') }</p>
                          <p>{ t('klis.klis-itinerar-txt-3') }</p>
                          <p>{ t('klis.klis-itinerar-txt-4') }</p>
                          <p>{ t('klis.klis-itinerar-txt-5') }</p>
                          <p>{ t('klis.klis-itinerar-txt-6') }</p>
                          <p>{ t('klis.klis-itinerar-txt-7') }</p>
                          <p>{ t('klis.klis-itinerar-txt-8') }</p>
                          <p>{ t('klis.klis-itinerar-txt-9') }</p>
                          <p>{ t('klis.klis-itinerar-txt-10') }</p>
                          <p>{ t('klis.klis-itinerar-txt-11') }</p>
                          <p>{ t('klis.klis-itinerar-txt-12') }</p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="info" className="morebtn">{ t('klis.klis-title-6') }</Button>
                    <UncontrolledCollapse toggler="#info">
                      <Card>
                        <CardBody>
                          
                          <ul>
                            <li>{ t('klis.klis-info-txt-1') }</li>
                            <li>{ t('klis.klis-info-txt-2') }</li>
                            <li>{ t('klis.klis-info-txt-3') }</li>
                            <li>{ t('klis.klis-info-txt-4') }</li>
                            <li>{ t('klis.klis-info-txt-5') }</li>
                            <li>{ t('klis.klis-info-txt-6') }</li>
                            <li>{ t('klis.klis-info-txt-7') }</li>
                          </ul>
                          
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <div>
                  <Button id="otkazivanje" className="morebtn">{ t('klis.klis-title-7') }</Button>
                    <UncontrolledCollapse toggler="#otkazivanje">
                      <Card>
                        <CardBody>
                           <p>
                          { t('klis.klis-cancel-txt') }
                          </p>
                        </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
                <hr className="line"/>

                <Kontaktizleti izlet="Klis"/>

              </div>
          </div>
    </div>
  );
}

export default Klis;

